import { Message } from 'element-ui'
var ui = {
  toast: (text, type) => {
    Message({
      message: text,
      type: type || 'error',
      offset: 170
    })
    // let html =
    //   `
    //       <div style="
    //       position: fixed;
    //       z-index:9999999;
    //       top:10%;
    //       left: 50%;
    //       background:#f9f9f9;
    //       color: #000;
    //       -webkit-transform: translate(-50%,-50%);
    //       -ms-transform: translate(-50%,-50%);
    //       transform: translate(-50%,-50%);
    //       font-size: 16px;
    //       padding: 11px 20px;
    //       border-radius:4px;
    //       transition:all 0.2s;
    //       height:auto;
    //       ">` +
    //   text + `</div>
    //       `
    // let div = document.body.appendChild(document.createElement('div'))
    // div.innerHTML = html

    // setTimeout(function () {
    //   div.style.opacity = 1
    // }, 1)
    // setTimeout(function () {
    //   div.style.opacity = 0
    //   setTimeout(function () {
    //     document.body.removeChild(div)
    //   }, 500)
    // }, 2000)
  },
  alert (title, con, callback) {
    let html =
      `<div class="pop" style="z-index:{{zIndex}};" >
          <div class="pop-con" id="dialogOutBox"  style="z-index:{{zIndex}};">
            <div class="pop-title" id="dialogHeater">
              <span>{{Title}}</span>
              <font class="pop-close" event_click="close"></font>
            </div>
            <div class="pop-info">
            	{{Con}}
            </div>
            <div class="pop-tool">
            	<span event_click="define">关闭</span>
            </div>
          </div>
        </div>`
    if (!top.zIndex) top.zIndex = 9999
    top.zIndex += 2
    let div = document.body.appendChild(document.createElement('div'))
    div.innerHTML = html.replace(/\{\{zIndex\}\}/g, top.zIndex)
      .replace(/\{\{Title\}\}/g, title)
      .replace(/\{\{Con\}\}/g, con)

    div.querySelectorAll('[event_click="define"]').forEach((item) => {
      item.onclick = () => {
        callback ? callback() : document.body.removeChild(div)
      }
    })
    div.querySelectorAll('[event_click="close"]').forEach((item) => {
      item.onclick = () => {
        document.body.removeChild(div)
      }
    })
    this.moveDialog('dialogOutBox', 'dialogHeater')
  },
  confirm (title, con, callback) {
    let html =
      `
      <div class="pop" style="z-index:{{zIndex}};" >
        <div class="pop-con" id="dialogOutBox"  style="z-index:{{zIndex}};">
          <div class="pop-title" id="dialogHeater">
            <span>{{Title}}</span>
            <font class="pop-close" event_click="close"></font>
          </div>
          <div class="pop-info">
          	{{Con}}
          </div>
          <div class="pop-tool">
          	<span event_click="close" style="margin-right:12px;">取消</span>
          	<span class="on"  event_click="define" style="margin-left:12px;">确定</span>
          </div>

        </div>
      </div>
          `
    if (!top.zIndex) top.zIndex = 9999
    top.zIndex += 2
    let div = document.body.appendChild(document.createElement('div'))
    div.className = 'confirmLayer'
    div.innerHTML = html.replace(/\{\{zIndex\}\}/g, top.zIndex)
      .replace(/\{\{Title\}\}/g, title)
      .replace(/\{\{Con\}\}/g, con)

    div.querySelectorAll('[event_click="define"]').forEach((item) => {
      item.onclick = () => {
        callback && callback()
        document.body.removeChild(div)
      }
    })
    div.querySelectorAll('[event_click="close"]').forEach((item) => {
      item.onclick = () => {
        document.body.removeChild(div)
      }
    })
    this.moveDialog('dialogOutBox', 'dialogHeater')
  },
  layer: {
    open (path, title, width, height, callback, getcallback) {
      let html =
        `
        <div class="pop" style="z-index:{{zIndex}};" event_click="close">
        	<div class="pop-con"  style="z-index:{{zIndex}};">
        		<div class="pop-title">
        			<span>{{Title}}</span>
        			<font class="pop-close" event_click="close"></font>
        		</div>
        		<iframe src="{{Path}}" style="width:{{Width}}px;height:{{Height}}px;" scrolling="yes" frameborder="0"></iframe>
        	</div>
        </div>

        `
      title = title || '弹出层'
      width = width || 800
      height = height || 500
      let funName = 'layer_' + Math.round(Math.random())
      path = path + (path.indexOf('?') > -1 ? '&' : '?') + 'LayerCallBack=' + funName
      if (!top.zIndex) top.zIndex = 9999
      top.zIndex += 2
      let div = document.body.appendChild(document.createElement('div'))
      div.innerHTML = html.replace(/\{\{zIndex\}\}/g, top.zIndex)
        .replace(/\{\{Title\}\}/g, title)
        .replace(/\{\{Path\}\}/g, path)
        .replace(/\{\{Width\}\}/g, width)
        .replace(/\{\{Height\}\}/g, height)

      top[funName] = function (data, type) {
        if (data == null) {
          if (type == 'close') document.body.removeChild(div)
          else if (type == 'get') return getcallback && getcallback()
        } else {
          callback && callback(data)
        }
      }
      obj.get(0).querySelectorAll('[event_click="close"]').forEach((item) => {
        item.onclick = () => {
          document.body.removeChild(div)
        }
      })
    },
    close: function () {
      var fun = $.string.path(location.href)['LayerCallBack']
      top[fun] && top[fun](null, 'close')
    },
    get: function () {
      var fun = $.string.path(location.href)['LayerCallBack']
      return top[fun] && top[fun](null, 'get')
    },
    set: function (data) {
      var fun = $.string.path(location.href)['LayerCallBack']
      top[fun] && top[fun](data)
    }
  },
  moveDialog (divId, headerId) {
    var dragDom = document.getElementById(divId)
    var dialogHeaderEl = document.getElementById(headerId)
    dialogHeaderEl.style.cssText += ';cursor:move;'
    var bDrag = false
    var disX = 0
    var disY = 0
    dialogHeaderEl.onmousedown = function (event) {
      var event = event || window.event
      bDrag = true
      disX = event.clientX - dragDom.offsetLeft
      disY = event.clientY - dragDom.offsetTop
      this.setCapture && this.setCapture()
      return false
    }
    document.onmousemove = function (event) {
      if (!bDrag) return
      var event = event || window.event
      var iL = event.clientX - disX
      var iT = event.clientY - disY
      var maxL = document.documentElement.clientWidth - dragDom.offsetWidth
      var maxT = document.documentElement.clientHeight - dragDom.offsetHeight
      iL = iL < 0 ? 0 : iL
      iL = iL > maxL ? maxL : iL
      iT = iT < 0 ? 0 : iT
      iT = iT > maxT ? maxT : iT

      dragDom.style.marginTop = dragDom.style.marginLeft = 0
      dragDom.style.left = iL + 'px'
      dragDom.style.top = iT + 'px'
      return false
    }
    document.onmouseup = window.onblur = dialogHeaderEl.onlosecapture = function () {
      bDrag = false
      dialogHeaderEl.releaseCapture && dialogHeaderEl.releaseCapture()
    }
  }
}
export default ui



// WEBPACK FOOTER //
// ./src/helpers/ui.js